<template>
  <div id="navbar">
    <div class="images">
      <img src="@/assets/images/logo_navbar.png" style="margin-right: 15px" />
      <label v-if="screenWidth < 987" class="pointer" @click="logout()"
        >CERRAR SESIÓN</label
      >
      <!-- <div class="logos">
        <img style="height: 43px" src="@/assets/images/icon_eco.png" />
        <div
          id="widget-container"
          class="ekomi-widget-container ekomi-widget-sf1385665ebd0c72aa651"
        >
          <div id="ekw109" class="pull-left">
            <div class="left-seal">
              <img
                src="https://smart-widget-assets.ekomiapps.de/resources/es_seal_silver-41.png"
                class="seal"
                title="eKomi silver seal Award"
                alt="eKomi silver seal"
              />
            </div>
            <div class="right-rating">
              <div class="stars-grey">
                <div class="stars-yellow" style="width:058px"></div>
              </div>
              <p class="total-revs">¡Excelente!</p>
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <label v-if="screenWidth >= 987" class="pointer" @click="logout()"
      >CERRAR SESIÓN</label
    >
  </div>
</template>

<script>
import AuthService from "../../services/auth.service";
export default {
  name: "navBar",
  data() {
    return {
      screenWidth: null
    };
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  methods: {
    handleResize() {
      this.screenWidth = screen.width;
    },
    logout() {
      AuthService.logout();
      this.$cookies.remove("token");
    }
  }
};
</script>
<style lang="css">
#navbar {
  position: relative;
  height: 146px;
  width: 100%;
  background: #f7f7f7;
  border-bottom: 1px solid #777777;
  padding: 35px 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
#navbar label {
  text-align: right;
  float: right;
}
#navbar label:hover {
  color: #ff00b9;
}
#navbar .images {
  display: flex;
}
#navbar .logos {
  display: flex;
  align-items: center;
  margin-left: 20px;
}

#navbar .logos img {
  margin: 0px 10px;
}

#widget-container #ekw109 .left-seal img {
  margin: 0px 10px 0px 0px !important;
}
#widget-container #ekw109 .right-rating {
  margin: 0;
  float: initial;
  width: 135px;
  float: left;
}

#widget-container #ekw109 .rating-figures {
  font-size: 17px;
}

#ekw109 .stars-grey {
  transform: scale(1.4, 1.4);
}

#widget-container div,
#widget-container span,
#widget-container p,
#widget-container img {
  background-color: transparent !important;
  color: black !important;
}
#widget-container #ekw109 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 141px;
  height: 43px;
  background: transparent !important;
  padding: 1px 4px 1px 5px;
}

#ekw109 .seal {
  width: 41px;
  height: 41px;
}
#ekw109 .left-seal {
  margin-right: 6px !important;
}

#ekw109 .stars-yellow {
  background-repeat: no-repeat;
  background: url("https://sw-assets.ekomiapps.de/resources/stars-yellow-62x10.png");
  height: 10px;
  max-width: 100%;
}

#ekw109 .stars-grey {
  background-repeat: no-repeat;
  margin-top: 1px;
  background: url("https://sw-assets.ekomiapps.de/resources/stars-grey-62x10.png");
  width: 62px;
  height: 10px;
  margin-right: 6px;
  float: left;
  margin-bottom: 6px;
}
#ekw109 .total-revs {
  margin: 0;
  font-size: 14px !important;
  line-height: 1;
}

@media (max-width: 991px) {
  #navbar .images {
    display: block;
    width: 100%;
  }
  #navbar .images label {
    margin-top: 30px;
  }
  #navbar .logos {
    margin: 10px 0px;
  }
}
@media (max-width: 768px) {
  #navbar {
    height: auto;
    align-items: start;
    padding: 30px 0px 3px 0px;
  }
  #navbar .images {
    display: block;
  }
}
@media (max-width: 480px) {
  #navbar .logos img {
    width: 100%;
    max-width: 100px;
    height: 100% !important;
  }
  #navbar .images label {
    width: 70px;
    margin-top: 15px;
  }
  #widget-container #ekw109 img.seal {
    width: 40px;
  }
  #ekw109 .total-revs,
  #ekw109 .rating-figures {
    font-size: 12px !important;
  }
  #widget-container #ekw109 .right-rating {
    width: 120px;
  }
}
</style>
